import React from 'react';

import clsx from 'clsx';

import { KbaQuestion } from 'api/KbaApi';

import styles from './StepsProgress.module.scss';

interface StepsProps {
  questions: KbaQuestion[];
  step: number;
}

const StepsProgress = ({ step, questions }: StepsProps) => {
  const steps = questions.map((question, index) => {
    const currentStepStyle = index === step && styles.currentStep;
    const passedStepStyle = index <= step && styles.passedStep;

    return <div className={clsx(styles.step, currentStepStyle, passedStepStyle)} key={question.questionType}></div>;
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperProgressBar}>{steps}</div>
    </div>
  );
};

export default StepsProgress;
